import {IDrawerContent} from "../../../../drawer/drawer.service.interface";
import {CyClass} from "../../../../../../common/cy-classes";
import {SpinnerBrandBox} from "../../../../../components/spinner/boxes/spinner-brand/spinner-brand.box";
import {SpinnerBackgroundBox} from "../../../../../components/spinner/boxes/spinner-background/spinner-background.box";
import {SpinnerBox} from "../../../../../components/spinner/boxes/spinner/spinner.box";
import React from "react";

export class DrawerSpinnerContent implements IDrawerContent {

    render(): React.ReactNode {
        return (
            <SpinnerBox className={CyClass('cy-spinner')}>
                <SpinnerBrandBox className='cy-spinner-brand'>
                    <SpinnerBackgroundBox className='cy-spinner-background'/>
                </SpinnerBrandBox>
            </SpinnerBox>
        );
    }
}